import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DataService} from '../../services/data.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_usaLow from '@amcharts/amcharts4-geodata/usaLow';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Subscription} from 'rxjs';

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-map-data',
  templateUrl: './map-data.component.html',
  styleUrls: ['./map-data.component.scss']
})
export class MapDataComponent implements OnInit, OnDestroy {
  private chart: am4maps.MapChart;
  mapStateData: any;
  statesValues: any;
  refreshChart: any;
  observable: Subscription;
  constructor(private zone: NgZone, private http: HttpClient, private dataService: DataService) {
  }

  ngOnInit() {
    this.observable = this.dataService.message.subscribe(data => {
      this.loadData(data);
    });
  }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
        this.observable.unsubscribe();
      }
    });
  }
  loadData(data) {
    this.statesValues = data['value'];
    this.refreshChart = data['remove'];
    if (this.refreshChart === true) {
      this.removeSeries();
    }
    this.mapStateData = [
      ['25', '43', '25', '32', '15', '11', '13', '5', '16', '18', '90', '2', '22', '78', '92', '82', '31', '3', '34', '56', '34', '36', '87', '44', '32', '12', '54', '2', '24', '13', '54', '63', '11'
        , '4', '54', '65', '86', '12', '53', '56', '94', '46', '2', '13', '24', '35', '36', '79', '26', '1'],
      ['13', '8', '2', '65', '35', '8', '53', '43', '2', '34', '56', '87', '0', '89', '4', '34', '24', '57', '08', '09', '69', '34', '56', '26', '73', '38', '29', '93', '53', '26', '65', '92', '76'
        , '23', '27', '42', '85', '25', '36', '61', '43', '54', '65', '33', '2', '11', '90', '42', '25', '32']];
    this.loadChart();
    // this.http.get('./assets/insurance-analytics.json')
    //   .subscribe((res) => {
    //     const datasize = res;
    //     for(let i= 0; i< datasize.length; i++) {
    //       console.log(res[i]['policy_state']);
    //     }
    //
    //   });
  }

  removeSeries() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  loadChart() {
    this.chart = am4core.create('chartdiv', am4maps.MapChart);
    this.chart.geodata = am4geodata_usaLow;
    this.chart.projection = new am4maps.projections.AlbersUsa();
    const polygonSeries = this.chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.heatRules.push({
      property: 'fill',
      target: polygonSeries.mapPolygons.template,
      min: this.chart.colors.getIndex(1).brighten(1),
      max: this.chart.colors.getIndex(1).brighten(-0.3)
    });
    polygonSeries.useGeodata = true;
    polygonSeries.data = [
      {
        id: 'US-AL',
        value: this.mapStateData[this.statesValues][0]
      },
      {
        id: 'US-AK',
        value: this.mapStateData[this.statesValues][1]
      },
      {
        id: 'US-AZ',
        value: this.mapStateData[this.statesValues][2]
      },
      {
        id: 'US-AR',
        value: this.mapStateData[this.statesValues][3]
      },
      {
        id: 'US-CA',
        value: this.mapStateData[this.statesValues][4]
      },
      {
        id: 'US-CO',
        value: this.mapStateData[this.statesValues][5]
      },
      {
        id: 'US-CT',
        value: this.mapStateData[this.statesValues][6]
      },
      {
        id: 'US-DE',
        value: this.mapStateData[this.statesValues][7]
      },
      {
        id: 'US-FL',
        value: this.mapStateData[this.statesValues][8]
      },
      {
        id: 'US-GA',
        value: this.mapStateData[this.statesValues][9]
      },
      {
        id: 'US-HI',
        value: this.mapStateData[this.statesValues][10]
      },
      {
        id: 'US-ID',
        value: this.mapStateData[this.statesValues][11]
      },
      {
        id: 'US-IL',
        value: this.mapStateData[this.statesValues][12]
      },
      {
        id: 'US-IN',
        value: this.mapStateData[this.statesValues][13]
      },
      {
        id: 'US-IA',
        value: this.mapStateData[this.statesValues][14]
      },
      {
        id: 'US-KS',
        value: this.mapStateData[this.statesValues][15]
      },
      {
        id: 'US-KY',
        value: this.mapStateData[this.statesValues][16]
      },
      {
        id: 'US-LA',
        value: this.mapStateData[this.statesValues][17]
      },
      {
        id: 'US-ME',
        value: this.mapStateData[this.statesValues][18]
      },
      {
        id: 'US-MD',
        value: this.mapStateData[this.statesValues][19]
      },
      {
        id: 'US-MA',
        value: this.mapStateData[this.statesValues][20]
      },
      {
        id: 'US-MI',
        value: this.mapStateData[this.statesValues][21]
      },
      {
        id: 'US-MN',
        value: this.mapStateData[this.statesValues][22]
      },
      {
        id: 'US-MS',
        value: this.mapStateData[this.statesValues][23]
      },
      {
        id: 'US-MO',
        value: this.mapStateData[this.statesValues][24]
      },
      {
        id: 'US-MT',
        value: this.mapStateData[this.statesValues][25]
      },
      {
        id: 'US-NE',
        value: this.mapStateData[this.statesValues][26]
      },
      {
        id: 'US-NV',
        value: this.mapStateData[this.statesValues][27]
      },
      {
        id: 'US-NH',
        value: this.mapStateData[this.statesValues][28]
      },
      {
        id: 'US-NJ',
        value: this.mapStateData[this.statesValues][29]
      },
      {
        id: 'US-NM',
        value: this.mapStateData[this.statesValues][30]
      },
      {
        id: 'US-NY',
        value: this.mapStateData[this.statesValues][31]
      },
      {
        id: 'US-NC',
        value: this.mapStateData[this.statesValues][32]
      },
      {
        id: 'US-ND',
        value: this.mapStateData[this.statesValues][33]
      },
      {
        id: 'US-OH',
        value: this.mapStateData[this.statesValues][34]
      },
      {
        id: 'US-OK',
        value: this.mapStateData[this.statesValues][35]
      },
      {
        id: 'US-OR',
        value: this.mapStateData[this.statesValues][36]
      },
      {
        id: 'US-PA',
        value: this.mapStateData[this.statesValues][37]
      },
      {
        id: 'US-RI',
        value: this.mapStateData[this.statesValues][38]
      },
      {
        id: 'US-SC',
        value: this.mapStateData[this.statesValues][39]
      },
      {
        id: 'US-SD',
        value: this.mapStateData[this.statesValues][40]
      },
      {
        id: 'US-TN',
        value: this.mapStateData[this.statesValues][41]
      },
      {
        id: 'US-TX',
        value: this.mapStateData[this.statesValues][42]
      },
      {
        id: 'US-UT',
        value: this.mapStateData[this.statesValues][43]
      },
      {
        id: 'US-VT',
        value: this.mapStateData[this.statesValues][44]
      },
      {
        id: 'US-VA',
        value: this.mapStateData[this.statesValues][45]
      },
      {
        id: 'US-WA',
        value: this.mapStateData[this.statesValues][46]
      },
      {
        id: 'US-WV',
        value: this.mapStateData[this.statesValues][47]
      },
      {
        id: 'US-WI',
        value: this.mapStateData[this.statesValues][48]
      },
      {
        id: 'US-WY',
        value: this.mapStateData[this.statesValues][49]
      }
    ];

// Set up heat legend
    const heatLegend = this.chart.createChild(am4maps.HeatLegend);
    heatLegend.series = polygonSeries;
    heatLegend.align = 'right';
    heatLegend.valign = 'bottom';
    heatLegend.width = am4core.percent(20);
    heatLegend.marginRight = am4core.percent(3);
    heatLegend.minValue = 0;
    heatLegend.maxValue = 40000000;

// Set up custom heat map legend labels using axis ranges
    const minRange = heatLegend.valueAxis.axisRanges.create();
    minRange.value = heatLegend.minValue;
    minRange.label.text = 'Less';
    const maxRange = heatLegend.valueAxis.axisRanges.create();
    maxRange.value = heatLegend.maxValue;
    maxRange.label.text = 'More';

// Blank out internal heat legend value axis labels
    heatLegend.valueAxis.renderer.labels.template.adapter.add('text', (labelText) => {
      return '';
    });

// Configure series tooltip
    const polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}: {value}';
    polygonTemplate.nonScalingStroke = true;
    polygonTemplate.strokeWidth = 0.5;

// Create hover state and set alternative fill color
    const hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#3c5bdc');
  }
}
